function myGifts(){
    this.stat={};
    this.id_max=0;
}
myGifts.prototype={
    init:function(obj){
        this.stat=copyObj(obj);
        var i;
        for(i in this.stat){
            this.id_max=Math.max(i,this.id_max);
        }
    },
    takeGift:function(gift_id){
        return copyObj(this.stat[gift_id]);
    },
    takeAll:function(){
        return copyObj(this.stat);
    }
};
_myGifts = new myGifts();